import type { BusinessLocker } from '@barboxx/models/types';

import { api } from '../api';
import { throwIfBadResponse } from '../utils';

const rootPath = 'business-lockers';

export function getLockers(query?: BusinessLocker.SearchQuery) {
    return throwIfBadResponse(
        api.get<BusinessLocker.SearchResponse>(`${rootPath}`, query)
    );
}

export function getLockerInfoFromDeviceId({
    deviceId,
}: BusinessLocker.DeviceInfoRequest) {
    return throwIfBadResponse(
        api.get<BusinessLocker.DetailsResponse>(`${rootPath}/deviceId`, {
            deviceId,
        })
    );
}

export function assignNewLocker(data: BusinessLocker.CreateRequest) {
    return throwIfBadResponse(
        api.post<BusinessLocker.DetailsResponse>(`${rootPath}`, data)
    );
}

export function getById(id: number) {
    return throwIfBadResponse(
        api.get<BusinessLocker.DetailsResponse>(`${rootPath}/${id}`)
    );
}

export function updateLocker(id: number, data: BusinessLocker.UpdateRequest) {
    return throwIfBadResponse(
        api.put<BusinessLocker.DetailsResponse>(`${rootPath}/${id}`, data)
    );
}

export function removeLocker(id: number) {
    return throwIfBadResponse(api.delete<BusinessLocker>(`${rootPath}/${id}`));
}
